export const DEV_URL = process.env.REACT_APP_DEV_URL || '';
export const JWT_TOKEN = 'auth-token';
export const STRIPE = process.env.REACT_APP_STRIPE || '';
export const ENV_NAME = process.env.REACT_APP_ENV_NAME || '';
